import { render, staticRenderFns } from "./navigation-menu-header-environment.component.vue?vue&type=template&id=bb68c6c6&scoped=true"
import script from "./navigation-menu-header-environment.component.vue?vue&type=script&lang=ts"
export * from "./navigation-menu-header-environment.component.vue?vue&type=script&lang=ts"
import style0 from "./navigation-menu-header-environment.component.vue?vue&type=style&index=0&id=bb68c6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb68c6c6",
  null
  
)

export default component.exports